var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAlignmentCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_70637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3951 0H3.60494C1.61399 0 0 2.10751 0 4.70726V19.2927C0 21.8925 1.61399 24 3.60494 24H36.3951C38.386 24 40 21.8925 40 19.2927V4.70726C40 2.10751 38.386 0 36.3951 0Z",
    fill: "#C9CACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7616 3.68555H6.23887C4.62969 3.68555 3.3252 5.38893 3.3252 7.49017V16.5093C3.3252 18.6106 4.62969 20.314 6.23887 20.314H33.7616C35.3707 20.314 36.6752 18.6106 36.6752 16.5093V7.49017C36.6752 5.38893 35.3707 3.68555 33.7616 3.68555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5807 18.6066H17.4186C16.247 18.6052 15.1238 18.1656 14.2955 17.384C13.4671 16.6025 13.0012 15.5429 13 14.4378V9.56847C13.0014 8.46346 13.4674 7.40409 14.2958 6.62273C15.1241 5.84137 16.2472 5.40174 17.4186 5.40039H22.5807C23.7522 5.40154 24.8755 5.84099 25.704 6.62237C26.5325 7.40375 26.9986 8.46334 27 9.56847V14.4378C26.9988 15.543 26.5328 16.6027 25.7043 17.3842C24.8757 18.1658 23.7524 18.6054 22.5807 18.6066ZM17.4186 6.12787C16.4514 6.12883 15.524 6.49178 14.8401 7.13693C14.1562 7.78208 13.7715 8.65681 13.7705 9.56918V14.4385C13.7713 15.351 14.1559 16.226 14.8398 16.8713C15.5238 17.5166 16.4512 17.8795 17.4186 17.8805H22.5807C23.5481 17.8795 24.4756 17.5166 25.1597 16.8713C25.8438 16.226 26.2285 15.3511 26.2295 14.4385V9.56918C26.2283 8.65674 25.8435 7.78206 25.1594 7.13693C24.4754 6.4918 23.548 6.12883 22.5807 6.12787H17.4186Z",
    fill: "#717273"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_70637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAlignmentCenter);
export default __webpack_public_path__ + "static/media/active-alignment-center.19573124eb73dc515f2df31bc825380a.svg";
export { ForwardRef as ReactComponent };